export const endStatus = [
  "Pre Ship",
  "Post-Ship",
  "Stack Week (stacked/+30M)",
  "Stack Week-1",
  "Stack Week-2",
  "Stack Week-3",
  "Stack Week-4 (unstacking/+30M)",
];

export const defectsKeys: string[] = [
  "Cracks, Holes, Perforations",
  "Label (wrong or none)",
  "Finish Damage, Finish Molding Defects or Flange",
  "Flange/Neck Ring Damage",
  "Incorrect or Mixed Bottles",
  "Internal/External Contamination",
  "Embedded Contamination (metal, glass or other extraneous material)",
  "Odor",
  "Wrong or Missing Layer, color, or other additive",
  "Date Code (Missing or non-legible)",
  "Air bubbles or surface depressions > 3mm",
  "Dimensional – Bottle FINISH",
  "Performance (other than barrier)",
  "Volume",
  "Crushed or Severely Dented",
  "Rocker Bottoms",
  "Under-blown (Diamond Feet, miss-formed, malformed)",
  "Mold Line Miss-Match or External Body Flash (flash not on threads)",
  "Off Center Gate (> 6 mm from center)",
  "Delamination (filling line impact)",
  "Flange/Neck ring damage (20 Tg 12oz Popeye Bottle)",
  "Air bubbles or surface depressions > 1mm & 3mm",
  "Dimensional – Bottle BODY",
  "Material Distribution (other than barrier related)",
  "Embedded Contamination (non-metal/glass)",
  "Denting / Creasing",
  "Label (pre-labeled or self labeled)",
  "Delamination (cosmetic)",
  "Color (level outside of spec range)",
  "Opacity",
  "Clarity (Haze, Pearlescence, Crystallinity, etc.)",
  "Off Center Gate (< 6 mm and > 3 mm from center)",
  "Appearance",
  "Air Bubble or surface depression > 1mm",
  "Total Defects",
  "Percent Defects",
  "Pass/Fail",
];

export const transitModes = [
  // "Truck-Air Ride",
  // "Truck-Leaf Spring",
  // "Rail",
  // "Air",
  // "OceanShip",
  // "Others",
  "Truck Air ride",
  "Truck leaf spring",
  "Rail",
  "Air",
  // "Sea",
  "Ocean/Ship",
  "Others"
];
